import { nanoid } from 'nanoid'

import { File, Folder } from '../types'

/**
 * @description 生成文件夹
 * @param options
 * @returns
 */
export function createFolder(options?: Partial<Folder>): Folder {
  const folder: Folder = {
    id: nanoid(),
    name: '',
    nameFields: [],
    nameLimitSize: 60,
    pid: '',
    children: [],
    isFolder: true,
    startNum: 1,
    accept: {
      classifyChains: [],
      supportedFiles: [],
    },
    metadata: {},
    ...(options ?? {}),
  }
  return folder
}

/**
 * @description 生成文件
 * @param options
 * @returns
 */
export function createFile(options?: Partial<File>): File {
  const file: File = {
    id: nanoid(),
    isFile: true,
    name: nanoid(),
    type: 'electronic_saw',
    pid: '',
    metadata: {},
    ext: '',
    ...(options ?? {}),
  }
  return file
}
